export default {
  methods: {
    // to populate tables
    getPresentMandates(mandates, tableType) {
      return mandates.filter(item => {
        if (tableType == "physical") {
          return (
            item.building_owner_id == item.representant_owner_id &&
            item.presence_status == this.mandatePresenceStatuses.physical
          );
        } else if (tableType == "video") {
          return (
            item.building_owner_id == item.representant_owner_id &&
            item.presence_status == this.mandatePresenceStatuses.video &&
            !item.dummy_video_presence_status
          );
        } else if (tableType == "dummy_video") {
          return (
            item.building_owner_id == item.representant_owner_id &&
            item.presence_status == this.mandatePresenceStatuses.video &&
            !!item.dummy_video_presence_status
          );
        }
      });
    },
    getMandatesRepresentedByContacts(mandates, tableType) {
      var MandatesRepresentedByContacts = mandates.filter(item => {
        if (tableType == "physical") {
          return (
            item.representant_contact_id != null &&
            item.presence_status == this.mandatePresenceStatuses.pouvoir
          );
        } else if (tableType == "video") {
          return (
            item.representant_contact_id != null &&
            item.presence_status == this.mandatePresenceStatuses.pouvoir_by_video &&
            !item.dummy_video_presence_status
          );
        } else if (tableType == "dummy_video") {
          return (
            item.representant_contact_id != null &&
            item.presence_status == this.mandatePresenceStatuses.pouvoir_by_video &&
            !!item.dummy_video_presence_status
          );
        }
      });
      MandatesRepresentedByContacts = this.getMainMandatesForContacts(
        MandatesRepresentedByContacts
      );

      return MandatesRepresentedByContacts;
    },
    getMandatesThatLeft(mandates, tableType) {
      var MandatesThatLeftOwners = mandates.filter(item => {
        if (tableType == "physical") {
          return (
            item.showed_up != 0 &&
            item.presence_status == this.mandatePresenceStatuses.not_present &&
            item.representant_owner_id == item.building_owner_id &&
            item.last_presence_status != this.mandatePresenceStatuses.video &&
            item.last_presence_status != this.mandatePresenceStatuses.pouvoir_by_video
          );
        } else if (tableType == "video") {
          return (
            item.showed_up != 0 &&
            item.presence_status == this.mandatePresenceStatuses.not_present &&
            item.representant_owner_id == item.building_owner_id &&
            (item.last_presence_status == this.mandatePresenceStatuses.video ||
              item.last_presence_status == this.mandatePresenceStatuses.pouvoir_by_video)
          );
        }
      });

      var MandatesThatLeftContacts = mandates.filter(item => {
        if (tableType == "physical") {
          return (
            item.presence_status == this.mandatePresenceStatuses.not_present &&
            item.representant_contact_id != null &&
            item.last_presence_status != this.mandatePresenceStatuses.video &&
            item.last_presence_status != this.mandatePresenceStatuses.pouvoir_by_video
          );
        } else if (tableType == "video") {
          return (
            item.presence_status == this.mandatePresenceStatuses.not_present &&
            item.representant_contact_id != null &&
            (item.last_presence_status == this.mandatePresenceStatuses.video ||
              item.last_presence_status == this.mandatePresenceStatuses.pouvoir_by_video)
          );
        }
      });
      MandatesThatLeftContacts = this.getMainMandatesForContacts(MandatesThatLeftContacts);

      var MandatesThatLeft = MandatesThatLeftContacts.concat(MandatesThatLeftOwners);
      MandatesThatLeft.forEach(m => {
        m["$disabled"] = true;
      });

      return MandatesThatLeft;
    },

    getMandatesRepresentedByContactsNotPresentYet(mandates, tableType) {
      var MandatesRepresentedByContacts = mandates.filter(item => {
        if (tableType == "video") {
          return (
            item.representant_contact_id != null &&
            item.presence_status == this.mandatePresenceStatuses.pouvoir_by_video_not_present_yet
          );
        } // ...
      });
      MandatesRepresentedByContacts = this.getMainMandatesForContacts(
        MandatesRepresentedByContacts
      );

      return MandatesRepresentedByContacts;
    },

    /** helper functions ... */
    getMainMandatesForContacts(mandates) {
      // !!!: avoid duplicates if there are more represented by him (contact) -- get only one and consider it main
      return [...new Map(mandates.map(item => [item["representant_contact_id"], item])).values()];
    },
  },
};
